import React from 'react';
import PropTypes from 'prop-types';
import dataAids from '../../constants/dataAids';
import { UX2 } from '@wsb/guac-widget-core';
import { mapContextToProps } from './BaseContainerContext';

const noProductStyles = {
  paddingTop: 'medium',
  textAlign: 'center'
};

class NoProducts extends React.Component {
  render() {
    const {
      Element: { Block, Text }
    } = UX2;
    return (
      <Block style={ noProductStyles }>
        <Text
          children={ this.props.translate('featured_products.new_products_coming_soon') }
          data-aid={ dataAids.PG_NO_PRODUCTS_MESSAGE_RENDERED }
        />
      </Block>
    );
  }
}

NoProducts.propTypes = {
  translate: PropTypes.func
};

NoProducts.defaultProps = {
  translate: () => {}
};

export default mapContextToProps(NoProducts, context => ({
  translate: context.translate
}));
